import { render } from "./MoonEventDisplay.vue?vue&type=template&id=0f0dff83&ts=true"
import script from "./MoonEventDisplay.vue?vue&type=script&lang=ts"
export * from "./MoonEventDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__